import React from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var FormFooterEnd = function (_a) {
    var onCancel = _a.onCancel, buttonMessageId = _a.buttonMessageId, _b = _a.buttonStyle, buttonStyle = _b === void 0 ? "default" : _b;
    return (React.createElement(Button, { buttonStyle: buttonStyle, marginBottom0: true, onClick: onCancel },
        React.createElement(FormattedMessage, { id: buttonMessageId })));
};
